import { useLocation } from 'wouter';
import { flushSync } from 'react-dom';

export const useViewTransitionLocation = () => {
    const [location, setLocation] = useLocation();

    const navigate = (to: string) => {
        if (!document.startViewTransition) {
            setLocation(to);
            return;
        }

        document.startViewTransition(() => {
            flushSync(() => {
                setLocation(to);
            });
        });
    };

    return [location, navigate] as const;
};
